import gql from 'graphql-tag';
import { kmsClient } from '../../apollo';
import { useQuery } from '@apollo/react-hooks';
import { PerformanceRule, PerformanceRuleVariables } from './__generated__/PerformanceRule';

export const PERFORMANCE_RULE_QUERY = gql`
  query PerformanceRuleQuery($id: ID!) {
    performanceRule(id: $id) {
      id
      name
      level
      evaluationSpec
      status
      createdBy
      executionSpec
      campaign {
        name
        id
      }
      createdAt
      updatedAt
      triggeredAt
      triggered
      articleIds
      ruleActivities {
        id
        activity
        details
        createdBy
        createdAt
      }
    }
  }
`;

export const usePerformanceRuleQuery = (variables: PerformanceRuleVariables) => {
  return useQuery<PerformanceRule, PerformanceRuleVariables>(PERFORMANCE_RULE_QUERY, {
    variables,
    client: kmsClient,
    fetchPolicy: 'network-only',
    notifyOnNetworkStatusChange: true
  });
};
